export const GET_CHOICE_COUNT = "GET_CHOICE_COUNT"
export const GET_CHOICE_COUNT_SUCCESS = "GET_CHOICE_COUNT_SUCCESS"
export const GET_CHOICE_COUNT_FAIL = "GET_CHOICE_COUNT_FAIL"
export const CLEAR_DATA = "CLEAR_DATA"
